// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Layout Grid Cell */
:host {
  line-height: normal;
}

:host(.editable),
.editable {
  position: relative;
  border: 1px solid var(--ids-color-palette-blue-20);
}

::slotted(.close-btn),
.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
}

/* Auto-fit grid with siblings layout */
:host(.ids-layout-grid-auto-fit-container) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}
:host(.ids-layout-grid-auto-fit-container) ::slotted(ids-data-grid[auto-fit]) {
  flex: 1 1 auto;
  min-height: 200px;
  width: 100%;
}
:host(.ids-layout-grid-auto-fit-container) ::slotted(:not(ids-data-grid)) {
  flex: 0 0 auto;
}
:host(.ids-layout-grid-auto-fit-container) ::slotted(ids-button) {
  align-self: baseline;
}

/* When a cell contains an auto-fit data grid (no siblings),
   constrain the cell so height: 100% resolves against the grid track */
:host(.ids-layout-grid-auto-fit-container.ids-layout-grid-no-siblings) {
  block-size: 100%;
  min-block-size: 0;
  min-inline-size: 0;
  overflow: visible;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  block-size: 100%;
  min-block-size: 0;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-layout-grid/ids-layout-grid-cell.scss"],"names":[],"mappings":"AAAA,yBAAA;AACA;EACE,mBAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,kDAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,UAAA;EACA,YAAA;AACF;;AAEA,uCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,QAAA;AACF;AACE;EACE,cAAA;EACA,iBAAA;EACA,WAAA;AACJ;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,oBAAA;AADJ;;AAKA;uEAAA;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAFF;;AAMA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAHF","sourcesContent":["/* Ids Layout Grid Cell */\n:host {\n  line-height: normal;\n}\n\n:host(.editable),\n.editable {\n  position: relative;\n  border: 1px solid var(--ids-color-palette-blue-20);\n}\n\n::slotted(.close-btn),\n.close-btn {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n}\n\n/* Auto-fit grid with siblings layout */\n:host(.ids-layout-grid-auto-fit-container) {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n\n  ::slotted(ids-data-grid[auto-fit]) {\n    flex: 1 1 auto;\n    min-height: 200px;\n    width: 100%;\n  }\n\n  ::slotted(:not(ids-data-grid)) {\n    flex: 0 0 auto;\n  }\n\n  ::slotted(ids-button) {\n    align-self: baseline;\n  }\n}\n\n/* When a cell contains an auto-fit data grid (no siblings),\n   constrain the cell so height: 100% resolves against the grid track */\n:host(.ids-layout-grid-auto-fit-container.ids-layout-grid-no-siblings) {\n  block-size: 100%;\n  min-block-size: 0;\n  min-inline-size: 0;\n  overflow: visible;\n}\n\n// Sticky layout - applied by ids-data-grid[sticky-layout] to propagate block-size constraint\n:host(.ids-data-grid-sticky-layout-ancestor) {\n  block-size: 100%;\n  min-block-size: 0;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
